
import {defineComponent} from "vue";
import MainCardPreloadComponent from "@/components/Cards/MainCardPreloadComp.vue";
import MainCardComponent from "@/components/Cards/MainCardComp.vue";
import {ModsType} from "@/types/IModsData";
import Api from '@/common/mods'
import ResponseType from '@/types/IResponse'
import MainheaderComponent from "@/components/Main-header/MainHeaderComp.vue";
interface State {
  topViewWeekMods: ModsType[],
  topDownloadsWeekMods: ModsType[]
  preloaders: {
    topViewWeekMods: boolean,
    topDownloadsWeekMods: boolean
  }
}

export default defineComponent({
  name: 'TopWeekCardsComponent',
  components: {MainheaderComponent, MainCardComponent, MainCardPreloadComponent},
  data: (): State => ({
    topViewWeekMods: [],
    topDownloadsWeekMods: [],
    preloaders: {
      topViewWeekMods: true,
      topDownloadsWeekMods: true
    }
  }),
  methods: {
    uploadTopViewsWeekMods() {
      Api.getTopViewsWeekMods((res: ResponseType) => {
        this.topViewWeekMods = res["data"]
        this.preloaders.topViewWeekMods = false
      })
    },
    uploadTopDownloadsWeekMods() {
      Api.getTopDownloadsWeekMods((res: ResponseType) => {
        this.topDownloadsWeekMods = res["data"]
        this.preloaders.topDownloadsWeekMods = false
      })
    }
  },
  created() {
    this.uploadTopViewsWeekMods()
    this.uploadTopDownloadsWeekMods()
  }
})
